export default __webpack_public_path__ + "static/media/coming-soon.d0e4ab41.png";